import { Image } from '@wwt/entities/api/search-response'

import { MAX_DISPLAY_PHOTOS_AMOUNT } from './constants/maxDisplayPhotosAmount'

export const limitDisplayPhotos = (images: Image[] | undefined) => {
	if (!images) {
		return null
	}
	return images.slice(0, MAX_DISPLAY_PHOTOS_AMOUNT)
}
